<template>
    <div class="modal coupon_rule_modal fade" v-bind:class="{in: isShowModal, active: isShow}">
        <div class="modal-dialog" :style="`width: 590px`">
            <div class="modal-content">
                <div class="common-modal-close" @click="close">
                    <img class="modal-close" src="https://resource.rcclchina.com.cn/TUI2PCImg/SearchPackage/modal-close.jpg">
                </div>
                <div class="modal-body" v-html="html"></div>
            </div>
        </div>
    </div>
</template>

<script>
    import { delayDev } from '@/utilities/tools'

    export default {
        name: 'CouponAlert',
        props: {
            text: {
                type: String,
                default: '',
            }
        },
        data: () => {
            return {
                isShow: false,
                html: '',
                isShowModal: false,
            }
        },
        watch: {
            text (newVal) {
                this.html = newVal
            },
            isShow (newVal) {
                if (newVal) {
                    delayDev(100, () => {
                        this.isShowModal = true
                    })
                } else {
                    this.isShowModal = false
                }
            }
        },
        methods: {
            show () {
                this.isShow = true
                document.body.style.overflow = 'hidden'
            },
            close () {
                this.isShow = false
                document.body.style.overflow = 'auto'
            }
        }
    }
</script>

<style lang="less" scoped>
    .coupon_rule_modal {
        &.active{
            display: block;
        }
        background-color: rgba(0,0,0,0.5);
        overflow: auto;
        .modal-dialog {
            top: 50px;
        }
        .modal-body {
            padding: 20px;
            width: 550px;
            color: #5a5a5a;
        }
        .common-modal-close {
            right: 20px;
        }
    }
</style>
